module.exports = __webpack_public_path__ + "img/loader.4f18e6e.svg";